import React from 'react';

interface Item {
  name: string;
  quantity: number;
  shipments: number;
}

interface DeliveryDate {
  date: string;
  items: Item[];
  total: number;
}

interface Props {
  data: DeliveryDate[];
  onClose: () => void;
}

const DeliveryModal: React.FC<Props> = ({ data, onClose }) => (
  <div
    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    onClick={onClose}
  >
    <div
      className="bg-white p-6 rounded-lg max-h-full overflow-y-auto w-full max-w-lg"
      onClick={onClose}
    >
      {data.map(d => (
        <div key={d.date} className="mb-4">
          <div className="font-bold text-xl mb-2">{d.date}</div>
          <ul className="mb-2">
            {d.items.map((item, idx) => (
              <li key={idx}>
                - {item.name}: {item.quantity} шт. ({item.shipments})
              </li>
            ))}
          </ul>
          <div className="font-semibold">Всего: {d.total}</div>
        </div>
      ))}
    </div>
  </div>
);

export default DeliveryModal;
